module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/geneve-a51d72178bd267c49866da295202557c.png";